import React, { useEffect, useState } from 'react'
import Iframe from 'react-iframe'
import {  URL_MAP_DEFAULT } from '../../../service/Config';

export default function P302Map({data}) {

    const [sentData, setSentData] = useState({
        contractNo : ""
    })

    useEffect(() => {
        setSentData({
            contractNo : data.contractNo ?data.contractNo:""
        })
    }, [data])

    return (
        <>
            {
                (sentData.contractNo !=="")?(
                    <Iframe
                        url={`${URL_MAP_DEFAULT()}/Map302?contractNo=${sentData.contractNo}&token=dev`}
                        width="100%"
                        height="600"
                        display="initial"
                        position="relative"
                    />
                ):('No Data')
            }
        </>
    )
}
